import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UtilitySharedService } from '../../../services/shared/utility-shared.service';
import { SubstationTemplateService } from '../../../services/substation-template.service';
import { SectionDefinition, SectionDefinitionEntityType } from '../../../models/section-definition.model';
import { SectionDefinitionService } from '../../../services/section-definition.service';
import { ToastrService } from 'ngx-toastr';
import { EquipmentTemplateDto, SubstationTemplateDto } from '../../../models/network-structure.model';
import { slideToggle } from '../../../helpers/slidetoggle';

@Component({
  selector: 'lib-substation-templates',
  templateUrl: './substation-templates.component.html',
  styleUrl: './substation-templates.component.scss',
  standalone: false,
  animations: [slideToggle]
})
export class SubstationTemplatesComponent implements OnInit {
  selectedClass: number = 0;
  utilityId: number = 0;
  addNewFieldOpened: boolean = false;
  sectionDefinitions: SectionDefinition[] = [];
  equipmentSectionDefinitions: SectionDefinition[] = [];
  substationTemplates: SubstationTemplateDto[] = [];
  equipmentTemplates: EquipmentTemplateDto[] = [];
  expandedSectionId: number = -1;
  equipmentSectionExpanded: boolean = false;

  classes: any = []

  constructor(private substationTemplateService: SubstationTemplateService,
              private utilitySharedService: UtilitySharedService,
              private sectionDefinitionService: SectionDefinitionService,
              private toastr: ToastrService,
              private cdr: ChangeDetectorRef
  ) {
    this.utilityId = Number(this.utilitySharedService.getUtilityId());
  }

  ngOnInit(): void {
    this.getClasses();
  }

  selectClass(index: number) {
    this.selectedClass = index;
    this.getSectionDefinitionsForClass(this.classes[index].entitytype, this.classes[index].substationTemplateId);
    this.equipmentSectionExpanded = false;
  }

  getClasses() {
    this.substationTemplateService.getAll(this.utilityId).subscribe({
      next: (response: any) => {
        this.substationTemplates = response?.body?.data || [];
        this.substationTemplates.forEach((el: any, i: number) => {
          this.classes.push({
            index: i,
            label: el.className,
            entitytype: SectionDefinitionEntityType.SubstationTemplate,
            substationTemplateId: el.id
          })
        })
        this.selectClass(0);
      }
    })
  }

  sectionSaved(data: any) {
    this.selectClass(
      this.classes.find((x: any) => x.substationTemplateId == data.substationTemplateId)?.index!
    );
    this.expandedSectionId = data.id;
  }

  getSectionDefinitionsForClass(entityType: number, substationTemplateId: number, equipmentType: number | null = null) {
    this.sectionDefinitionService.getAllSectionDefinitionsForDmc(entityType, this.utilityId, substationTemplateId, equipmentType).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          if (entityType != SectionDefinitionEntityType.EquipmentTemplate) {
          this.sectionDefinitions = responseData?.data?.length
            ? responseData?.data?.map((el: any) => new SectionDefinition(el))
            : [];
          } else {
            this.equipmentSectionDefinitions = responseData?.data?.length
              ? responseData?.data?.map((el: any) => new SectionDefinition(el))
              : [];
          }
          if (responseData.message !== '') {
            this.toastr.warning(responseData.message);
          }
        } else {
          this.toastr.error(responseData?.message);
        }
        5;
      },
      error: () => this.toastr.error('Error occurred'),
    });
  }

  onSectionUpdated(data: any) {
    this.selectClass(
      this.classes.find((x: any) => x.substationTemplateId == data.substationTemplateId)?.index!
    );
  }

  sectionDeleted(id: any) {
    this.sectionDefinitions = this.sectionDefinitions.filter(x => x.id != id);
    this.cdr.detectChanges();
  }

  onExpandEquipmentsSection() {
    this.equipmentSectionExpanded = !this.equipmentSectionExpanded;
  }
}
